import React, { useState, useEffect } from "react";
import MaterialTable, { MTableToolbar } from "material-table";
import { ToastContainer, toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import "react-sliding-pane/dist/react-sliding-pane.css";
import _ from "lodash";
import ContentLoader from "react-content-loader";
import { Link, useNavigate } from "react-router-dom";

import { API } from "../../../backend";
import authHeader from "../../../services/auth-header";
import { getTrans as t } from "../../../Localization/translations";
import Helper from "../../../Helper";
import DeleteRatecardService from "../../../services/inventory/ratecardDeleteServices";

function RatecardTable() {
  const RatecardtableRef = React.createRef();

  const [loading, setLoading] = useState(true);

  const [permissionss,setPermission] = useState(localStorage.getItem('permissions'))
  const permissionsArray = permissionss.split(',');
  let navigate = useNavigate();

  const handleEdit = (id) => {
    navigate("/editratecardheader", { state: id });
  };

  const handleView = (id) => {
    navigate("/ratecardheaderview", { state: id });
  };

  useEffect(() => {
    setLoading(false);
  }, []);

  const handelDelete = (id) => {
    confirmAlert({
      title: "",
      message: "Are you sure you want to delete this Ratecard?.",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            DeleteRatecardService.deleteratecard(id).then((response) => {
              if (response.data.success) {
                toast.success(`${response.data.response}`, {
                  position: "top-right",
                  autoClose: 1000,
                  hideProgressBar: false,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
                RatecardtableRef.current.onQueryChange();
              } else {
                toast.error(`${response.data.error}`, {
                  position: "top-right",
                  autoClose: 1000,
                  hideProgressBar: false,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
              }
            })
          },
        },
        {
          label: "No",
        },
      ],
    });
  };

  return (
    <>
      {loading === false ? (
        <div className="page-wrapper">
          <ToastContainer />
          <div className="content container-fluid">
            <div className="row">
              <div className="">
                <div className="ms-auto my-auto mt-lg-0 mt-4">
                  <div className="ms-auto my-auto"></div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="">
                  <div className="body">
                    <div className="pt-4">
                      <MaterialTable
                        tableRef={RatecardtableRef}
                        style={{
                          backgroundColor: "var(--bs-table-bg)",
                          borderBottomWidth: "1px",
                          boxShadow:
                            "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                        }}
                        onRowClick={(event, rowData) => {
                          handleView(rowData.id);
                        }}
                        title={
                          <h5 className="d-lg-flex">{t("Rate Card")}</h5>
                        }
                        columns={[
                          {
                            title: `${t("Card Name")}`,
                            field: "cardname",
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                            render: (rowData) => (
                              <>
                              <div className="d-xl-none tc d-md-none d-lg-none">
                                {t("Card Name")}{" "}
                              </div>
                              <div className="hyperlink">
                                {rowData.cardname}
                              </div>
                              </>
                            ),
                          },
                          {
                            title: `${t("Effective Form")}`,
                            field: "effectiveform",
                            render: (rowData) =>
                            <>
                            <div className="d-xl-none tc d-md-none d-lg-none">
                              {t("Effective Form")}{" "}
                            </div>
                            <div>
                              {rowData.effectiveform
                                ? Helper.Dateview(rowData.effectiveform)
                                : "None"}</div></>,
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("Effective To")}`,
                            field: "effectiveto",
                            render: (rowData) =>
                            <>
                            <div className="d-xl-none tc d-md-none d-lg-none">
                              {t("Effective To")}{" "}
                            </div>
                            <div>{
                              rowData.effectiveto
                                ? Helper.Dateview(rowData.effectiveto)
                                : "None"}</div></>,
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                        ]}
                        data={(query) =>
                          new Promise((resolve, reject) => {
                            let url = API + "inventory/ratecard/?";
                            url += "per_page=" + query.pageSize;
                            url += "&page=" + (query.page + 1);
                            url += "&search=" + query.search;
                            fetch(url, { headers: authHeader() })
                              .then((response) => response.json())
                              .then((result) => {
                                resolve({
                                  data:
                                    query.orderBy && query.orderDirection
                                      ? _.orderBy(
                                          result.data,
                                          [query.orderBy.field],
                                          [query.orderDirection]
                                        )
                                      : result.data,
                                  page: result.page - 1,
                                  totalCount: result.total,
                                });
                              });
                          })
                        }
                        localization={{
                          toolbar: {
                            searchPlaceholder: "Search Item",
                          },
                        }}
                        actions={[
                          {
                            icon: () => (
                              permissionss &&  permissionsArray.includes('change_ratecardheader')===true ? 
                              <img
                                src={
                                  process.env.PUBLIC_URL +
                                  "/static/images/ic-edit.svg"
                                }
                                alt="edit"
                              />
                              :""
                            ),
                            tooltip: "Edit",
                            onClick: permissionss &&  permissionsArray.includes('change_ratecardheader')===true ? (event, rowData) => {
                              handleEdit(rowData.id);
                            }:"",
                          },
                          {
                            icon: () => (
                              permissionss &&  permissionsArray.includes('delete_ratecardheader')===true ? 
                              <img
                                src={
                                  process.env.PUBLIC_URL +
                                  "/static/images/ic-delete.svg"
                                }
                                alt="delete"
                              />
                              :""
                            ),
                            tooltip: "Delete",
                            onClick: permissionss &&  permissionsArray.includes('delete_ratecardheader')===true ? (event, rowData) => {
                              handelDelete(rowData.id);
                            }:"",
                          },
                        ]}
                        components={{
                          Toolbar: (props) => (
                            <div className="MuiToolbar-root MTableToolbar-spacer-21  my-temp-class">
                              <MTableToolbar {...props} />
                {
                  permissionss &&  permissionsArray.includes('add_ratecardheader')===true ? 
                
                              <Link
                                className="navbar-brand m-0"
                                to="/addratecardheader"
                              >
                                <button
                                  className="add-party add btn btn-primary  mb-0"
                                  id="add-task"
                                >
                                  +&nbsp; {t("Add Ratecard")}
                                </button>
                              </Link>
                              :""
                        }
                            </div>
                          ),
                        }}
                        options={{
                          headerStyle: {
                            backgroundColor: "white",
									color: "#245C7F",
                            fontSize: 12,
                          },
                          rowStyle: (rowData, index) => {
                            if (index % 2) {
                              return { backgroundColor: "#fff" };
                            }
                          },
                          sorting: true,
                          search: false,
                          toolbar: true,
                          paging: true,
                          pageSize: 10, // make initial page size
                          emptyRowsWhenPaging: false, // To avoid of having empty rows
                          pageSizeOptions: [10, 20, 25, 50],
                          paginationType: "stepped",
                          showFirstLastPageButtons: false,
                          exportFileName: "Inventory",
                          actionsColumnIndex: -1,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <ContentLoader
          viewBox="0 0 1000 550"
          backgroundColor="rgba(0,0,0,0.06)"
          foregroundColor="rgba(0,0,0,0.12)"
        >
          <rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
          <circle cx="879" cy="123" r="11" />
          <circle cx="914" cy="123" r="11" />
          <rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
          <rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
          <rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
          <rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
          <circle cx="880" cy="184" r="11" />
          <circle cx="915" cy="184" r="11" />
          <rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
          <rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
          <rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
          <rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
          <circle cx="881" cy="242" r="11" />
          <circle cx="916" cy="242" r="11" />
          <rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
          <rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
          <rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
          <rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
          <circle cx="882" cy="303" r="11" />
          <circle cx="917" cy="303" r="11" />
          <rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
          <rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
          <rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
          <rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
          <circle cx="881" cy="363" r="11" />
          <circle cx="916" cy="363" r="11" />
          <rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
          <rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
          <rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
          <rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
          <circle cx="882" cy="424" r="11" />
          <circle cx="917" cy="424" r="11" />
          <rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
          <rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
          <rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
          <rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
          <rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
          <rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
          <circle cx="882" cy="484" r="11" />
          <circle cx="917" cy="484" r="11" />
          <rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
          <rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
          <rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
          <rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
          <rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
          <rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
          <rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
          <rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
          <rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
          <rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
        </ContentLoader>
      )}
    </>
  );
}

export default RatecardTable;
